import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import React, { useRef } from 'react';
import { ITreatmentConsultationExam } from 'types';

import DeleteIcon from '@mui/icons-material/Delete';
import {
  Autocomplete,
  Box,
  IconButton,
  Stack,
  StackProps,
  Tooltip,
} from '@mui/material';

import { StyledBoldInput, StyledLightInput } from './styles';
import { Controller } from 'react-hook-form';
import { requiredMessage } from 'schemas/validators';

const getInputName = (name: string, index: number) =>
  `prescription.${index}.${name}`;

interface Props extends StackProps {
  onDeleteClick: () => void;
  index: number;
  exams: ITreatmentConsultationExam[];
}

export const TreatmentPrescriptionExamItem: React.FC<Props> = ({
  onDeleteClick,
  index,
  exams,
  ...props
}) => {
  const indicationInputRef = useRef<any>(null);

  return (
    <Stack
      spacing={2}
      flex={1}
      border="1px solid #8E8E8E"
      borderRadius="4px"
      p={2}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      {...props}
    >
      <Stack flex={1}>
        <Controller
          name={getInputName('name', index)}
          render={({ field: { value, name, onChange } }) => {
            return (
              <Autocomplete
                id="examName"
                options={exams}
                getOptionLabel={(option) => option.name}
                popupIcon={null}
                fullWidth
                openOnFocus
                size="small"
                noOptionsText="Exame não encontrado"
                onChange={(_, value) => {
                  onChange(value?.name ?? '');

                  if (value?.name) {
                    indicationInputRef.current?.focus();
                    setTimeout(() => {
                      indicationInputRef.current?.focus();
                    }, 100);
                  }
                }}
                value={{ name: value ?? '' }}
                renderInput={(params) => (
                  <StyledBoldInput
                    rules={{
                      required: requiredMessage('Exame'),
                    }}
                    name={name}
                    placeholder="Buscar exame"
                    autoFocus
                    {...params}
                  />
                )}
                renderOption={(props, option, { inputValue }) => {
                  const matches = match(option.name, inputValue, {
                    insideWords: true,
                  });
                  const parts = parse(option.name, matches);

                  return (
                    <li {...props}>
                      <div>
                        {parts.map((part, index) => (
                          <span
                            key={index}
                            style={{
                              fontWeight: part.highlight ? 700 : 400,
                              color: part.highlight ? '#FBB45F' : '#000',
                            }}
                          >
                            {part.text}
                          </span>
                        ))}
                      </div>
                    </li>
                  );
                }}
              />
            );
          }}
        />

        <StyledLightInput
          name={getInputName('indication', index)}
          rules={{
            required: requiredMessage('Indicação'),
          }}
          placeholder="Indicação"
          fullWidth
          size="small"
          inputRef={indicationInputRef}
        />
      </Stack>

      <Box>
        <Tooltip title="Deletar">
          <IconButton aria-label="Deletar" onClick={onDeleteClick}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  );
};
